// Talk routes stay on the current consumer/white-label origin. Website links
// use config.home, and only public attribution parameters cross to that origin.
const attributionKeys = new Set(['ref', 'channel', 'uuid', 'org', 'gclid', 'fbclid', 'msclkid'])

export function localizedPortalPath(path, language) {
  const cleanPath = '/' + String(path || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '')
  const lang = /^[a-z]{2,3}(?:[-_][a-zA-Z]+)?$/.test(language || '') ? language.replace('_', '-') : 'en'
  return (cleanPath === '/' ? '' : cleanPath) + '/' + lang
}

export function portalAttribution(query = {}, ref = '') {
  const result = {}
  for (const [key, value] of Object.entries(query)) {
    if ((attributionKeys.has(key) || /^utm_[a-z_]+$/.test(key)) && typeof value === 'string') result[key] = value
  }
  if (!result.ref && typeof ref === 'string' && ref) result.ref = ref
  return result
}

export function buildPortalRoute(path, language, query = {}, ref = '', extra = {}) {
  // Login/reset links can retain the selected tutor without forwarding login
  // credentials or modal trigger flags such as login=1 to the next page.
  const teacher = typeof query.teacher_id === 'string' && /^\d+$/.test(query.teacher_id) ? { teacher_id: query.teacher_id } : {}
  return { path: localizedPortalPath(path, language), query: { ...portalAttribution(query, ref), ...teacher, ...extra } }
}

export function buildPortalHomeUrl(home, path, language, query = {}, ref = '') {
  const url = new URL(localizedPortalPath(path, language), home.replace(/\/+$/, '') + '/')
  url.searchParams.set('r', 'force')
  for (const [key, value] of Object.entries(portalAttribution(query, ref))) url.searchParams.set(key, value)
  return url.href
}

export function portalLanguageUrl(href, language, supportedLanguages, returnAction = '') {
  const url = new URL(href)
  const normalize = value => String(value || '').replace(/_/g, '-').toLowerCase()
  const languages = new Map(supportedLanguages.map(code => [normalize(code), code]))
  const locale = languages.get(normalize(language)) || 'en'
  const segments = url.pathname.replace(/\/+$/, '').split('/')
  // Replace only a recognized locale; preserve the current page and all URL parameters.
  if (languages.has(normalize(segments[segments.length - 1]))) segments.pop()
  url.pathname = segments.join('/') + '/' + locale
  if (returnAction) url.searchParams.set('action', returnAction)
  return url.href
}
